import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import withI18n, { I18nProps } from 'utils/i18n/withI18n';

class MarscoCommissionsUS extends Component<I18nProps> {
    render() {
        const { __, printf } = this.props.i18n;

        return (
            <div className="page-pricing-commissions a-flyRightIn">
                <Helmet>
                    <title>{__('Pricing and Commission - TradeUP')}</title>
                    <meta name="description" content={__('Discover the pricing system when trading with TradeUP!')} />
                </Helmet>
                <h3 className="title">{__('U.S. Stock & ETFs')}</h3>
                <div className="pricing-table-wrap">
                    <Table className="pricing-table">
                        <tbody>
                            <tr>
                                <td>{__('Commission (Listed)')}</td>
                                <td>$0</td>
                            </tr>
                            <tr>
                                <td>{__('Commission (OTC)')}</td>
                                <td>
                                    {printf(
                                        __(
                                            '%s/Share with maximum of %s*Value of Aggregate Transaction (Additional fees and interest may be charged for trading activity that triggers an NSCC or exchange illiquidity charge)'
                                        ),
                                        '$0.0002',
                                        '$0.05'
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td
                                    dangerouslySetInnerHTML={{
                                        __html: printf(__('SEC Fees%s （Charged to sell orders only)'), '<sup>1</sup>')
                                    }}
                                />
                                <td
                                    dangerouslySetInnerHTML={{
                                        __html: printf(
                                            __('%s%sValue of Aggregate Sales with minimum of %s/Order'),
                                            '$0.000008',
                                            '<sup>*</sup>',
                                            '$0.01'
                                        )
                                    }}
                                />
                            </tr>
                            <tr>
                                <td>{__('FINRA Trading Activity Fee (Charged to sell orders only)')}</td>
                                <td>{printf(__('%s/Share with maximum of %s/Order'), '$0.000145', '$7.27')}</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>

                <h3 className="title">{__('U.S. Equity and Index Options')}</h3>
                <div className="pricing-table-wrap">
                    <Table className="pricing-table">
                        <tbody>
                            <tr>
                                <td>{__('Commission')}</td>
                                <td>$0</td>
                            </tr>
                            <tr>
                                <td>{__('Contract Fee')}</td>
                                <td>{printf(__('%s/Contract'), '$0')}</td>
                            </tr>
                            <tr>
                                <td
                                    dangerouslySetInnerHTML={{
                                        __html: printf(__('Option Regulatory Fee (ORF)%s'), '<sup>2</sup>')
                                    }}
                                />
                                <td>{printf(__('%s/Contract'), '$0.01925')}</td>
                            </tr>
                            <tr>
                                <td
                                    dangerouslySetInnerHTML={{
                                        __html: printf(__('SEC Fees%s （Charged to sell orders only)'), '<sup>1</sup>')
                                    }}
                                />
                                <td
                                    dangerouslySetInnerHTML={{
                                        __html: printf(
                                            __('%s%sValue of Aggregate Sales with minimum of %s/Order'),
                                            '$0.000008',
                                            '<sup>*</sup>',
                                            '$0.01'
                                        )
                                    }}
                                />
                            </tr>
                            <tr>
                                <td>{__('FINRA Trading Activity Fee (Charged to sell orders only)')}</td>
                                <td>{printf(__('%s/Contract'), '$0.00244')}</td>
                            </tr>
                            <tr>
                                <td>{__('OCC Clearing Fee')}</td>
                                <td>{__('$0.02/Contract, with maximum of $55/Order')}</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>

                <h3 className="title">{__('Interest on Idle Cash (Annual Rate)')}</h3>
                <div className="pricing-table-wrap">
                    <Table className="pricing-table">
                        <tbody>
                            <tr>
                                <td
                                    dangerouslySetInnerHTML={{
                                        __html: printf(__('Interest on Idle Cash%s (Annual Rate)'), '<sup>3</sup>')
                                    }}
                                />
                                <td>{__('0.1% with minimum payout amount of $1')}</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>

                <h3 className="title">{__('Other Fees')}</h3>
                <div className="pricing-table-wrap">
                    <Table className="pricing-table">
                        <tbody>
                            <tr>
                                <td>{__('Confirmation Mailing Fee')}</td>
                                <td>$1</td>
                            </tr>
                            <tr>
                                <td>{__('Statements Mailing Fee')}</td>
                                <td>$2</td>
                            </tr>
                            <tr>
                                <td>{__('Voluntary Reorganizations')}</td>
                                <td>$25</td>
                            </tr>
                            <tr>
                                <td>{__('Issue Stock Certificate')}</td>
                                <td>$75</td>
                            </tr>
                            <tr>
                                <td
                                    dangerouslySetInnerHTML={{
                                        __html: printf(__('Wire Out Fee%s'), '<sup>4</sup>')
                                    }}
                                />
                                <td>$50</td>
                            </tr>
                            <tr>
                                <td>{__('ACATS Out Fee (Full Account Out)')}</td>
                                <td>$50</td>
                            </tr>
                            <tr>
                                <td>{__('ACH Reversal Fee')}</td>
                                <td>$30</td>
                            </tr>
                            <tr>
                                <td>{__('DRS/DWAC Transaction Fee')}</td>
                                <td>$150</td>
                            </tr>
                            <tr>
                                <td>{__('DRS/DWAC Rejection Fee')}</td>
                                <td>$150</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>

                <h3 className="title">{__('Margin Interest')}</h3>
                <div className="pricing-table-wrap">
                    <Table className="pricing-table">
                        <thead>
                            <tr>
                                <th></th>
                                <th>{__('Flat Rate')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td
                                    dangerouslySetInnerHTML={{
                                        __html: printf(__('Annual Margin Interest Rate%s'), '<sup>5</sup>')
                                    }}
                                />
                                <td>1.99%</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>

                <h3
                    className="title"
                    dangerouslySetInnerHTML={{
                        __html: printf(__('Short Interest Rate%s'), '<sup>6</sup>')
                    }}></h3>
                <div className="pricing-description-wrap">
                    <article>
                        {__('Short Interest Rate:')}
                        {__(
                            'Certain fees or short sell interest rates may apply. The rate fluctuates daily depending on the security’s market demand.'
                        )}
                    </article>
                    <hr />
                </div>

                <p className="sm-title">
                    <strong>{__('Notes')}</strong>
                </p>
                <section className="notes">
                    <article
                        dangerouslySetInnerHTML={{
                            __html: printf(
                                __(
                                    '1. SEC fees are only charged for sell orders. Under Section 31 of the Securities Exchange Act of 1934, U.S. national securities exchanges are obligated to pay transaction fees to the SEC based on the volume of securities that are sold on their markets. Exchange rules require their broker-dealer members to pay a share of these fees who, in turn, pass the responsibility of paying the fees to their customers. Only applies to sell transactions and appears on the trade confirmation as: “FEES”. View %s.'
                                ),
                                `<a target="view_window" href="https://www.sec.gov/fast-answers/answerssec31htm.html">${__(
                                    'more'
                                )}</a>`
                            )
                        }}
                    />
                    <article>
                        {__(
                            '2. The Option Regulatory Fee (“ORF”) is charged by the following exchanges: AMEX, BATS, BOX, CBOE, CBOE2, EDGX, EMERALD, ISE, GEMINI, MERCURY, MIAX, MERCURY, NOM, NASDAQBX, PSE, PHLX.'
                        )}
                    </article>
                    <article>
                        {__(
                            '3. Cash balances receive interest for each day your free credit balance exceeds $1000 as long as interest accrued is at least $1 per month. We reserve the right to change our credit interest rates (even to 0%) in response to changes in interest rates or other factors.'
                        )}
                    </article>
                    <article>
                        {__(
                            '4. TradeUP Securities, Inc. withdrawal fees do not cover third-party fees. The account holder will be solely responsible for any fees assessed by a beneficiary or correspondent bank. In addition, processing fees charged by your bank or its correspondent bank, which are not included in TradeUP Securities, Inc. withdrawal fees, may be deducted from wire proceeds.'
                        )}
                    </article>
                    <article>
                        {__(
                            `5. The margin rates become effective beginning from 10/01/2021. TradeUP Securities, Inc. (TradeUP Securities) accrues interest on a daily basis and posts actual interest monthly on the last business day of the month. When determining the annualized margin interest rate, TradeUP Securities utilizes commercially recognized rates as our benchmark. The rate may change from time to time at TradeUP Securities' full discretion without prior notification to clients. For complete details, please refer to the Account Agreement. `
                        )}
                    </article>
                    <br />
                    <br />
                    <ul className="marsco-footnotes-ul">
                        <li>
                            {__(
                                'Orders executed in multiple lots on the same day are charged a single commission; orders partially executed over multiple trading days are subject to commission charges for each trading day. Changes made to orders after partial execution are considered a new order.'
                            )}
                        </li>
                        <li
                            dangerouslySetInnerHTML={{
                                __html: printf(
                                    __(
                                        'Options trading entails significant risk and is not appropriate for all investors. Certain complex options strategies carry additional risk. Before trading options, please read %s. Supporting documentation for any claims, if applicable, will be furnished upon request.'
                                    ),
                                    `<a href="https://www.theocc.com/Company-Information/Documents-and-Archives/Publications" target="view_window">${__(
                                        'Characteristics and Risks of Standardized Options'
                                    )}</a>`
                                )
                            }}></li>
                        <li>
                            {__(
                                'Commissions and fees may change from time to time. TradeUP Securities, Inc. reserves the right to adjust the rates at any time, without given advanced notice.'
                            )}
                        </li>
                        <li>
                            {__(
                                'TradeUP Securities, Inc. does not charge an option exercise or assignment fee. Certain transactions are subject to the standard commissions for the applicable products.'
                            )}
                        </li>
                        <li>
                            {__(
                                'Taxes related to TradeUP Securities, Inc. offers are your responsibility. All Promotional items and cash received during the calendar year will be included on your consolidated Form 1099. Please consult a legal or tax advisor for the most recent changes to the U.S. tax code.'
                            )}
                        </li>
                        <li>
                            {__(
                                'Short Borrow Fee may be assessed on any day from the settlement date of the short-sell, up to and including the settlement date of the buy-cover; the rate varies and depends on factors including but not limited to market supply/demand.'
                            )}
                        </li>
                        <li>
                            {__(
                                'Margin interest rates vary due to the base rate and the size of the debit balance. When setting base rates, TradeUP Securities, Inc. considers indicators like prime rate, or other commercially recognized interest rates.'
                            )}
                        </li>
                    </ul>
                    <article>
                        {__(
                            '6. Short sell interest rate is charged on the net short position market value, which is marked to market daily.'
                        )}
                    </article>
                    <br />
                    <br />
                    <ul className="marsco-footnotes-ul">
                        <li>
                            {__(
                                'By short selling Hard-to-Borrow (HTB) equity securities, client agrees to allow TradeUP Securities, Inc. to locate shares and the trade will be charged an annualized fee (may vary daily) upon settlement for each day you remain short.'
                            )}
                        </li>
                        <li>
                            {__(
                                'Whether a security is eligible for short sell may vary depending on its associated risk or its market demand.'
                            )}
                        </li>
                        <li>
                            {__(
                                'Whether a security is Easy-to-Borrow or Hard-to-Borrow may vary daily depending on its supply and demand on the market.'
                            )}
                        </li>
                        <li>
                            {__(
                                'Short sell interest is accrued daily and charged weekly. Detailed charge records can be found on the monthly statement.'
                            )}
                        </li>
                        <li>{__('Short positions are at risk of forced buy back without advance notice.')}</li>
                    </ul>
                    <strong>{__('Overall short risk disclosure')}</strong>
                    <article>
                        {__(
                            'There are risks associated with short selling, including the risk of unlimited losses and incurrence of margin interest debt. Short selling is not suitable for all investors. Customers should make their own determination of whether a short selling strategy is consistent with their investment objectives, financial situation, and risk tolerance. TradeUP/TradeUP Securities, Inc. does not recommend or endorse the investment of securities that are made available for short sell. Short sell can only be placed in a margin account with total account equity of $2000 or above.'
                        )}
                    </article>
                </section>
            </div>
        );
    }
}

export default withI18n(MarscoCommissionsUS);
